import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import getApiClient from "@/lib/api";
import { unwrap } from "@/lib/api/error";
export function useNotifications() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getApiClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const apiClient = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["notifications"],
      queryFn: async () => unwrap(await apiClient.GET("/api/notifications")),
      refetchInterval: 30000
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useQuery(t1);
}
export function useMarkNotificationsSeen() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getApiClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const apiClient = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      unwrap(await apiClient.POST("/api/notifications/seen"));
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== queryClient) {
    t2 = {
      mutationFn: t1,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["notifications"]
        });
      }
    };
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useMutation(t2);
}
export function useMarkNotificationRead() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getApiClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const apiClient = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async notificationId => {
      unwrap(await apiClient.POST("/api/notifications/{notification_id}/read", {
        params: {
          path: {
            notification_id: notificationId
          }
        }
      }));
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== queryClient) {
    t2 = {
      mutationFn: t1,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["notifications"]
        });
      }
    };
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useMutation(t2);
}